export interface Closeable {
  close(e: CustomEvent) : void
}